import styled, { css } from "styled-components";

export const Content = styled("div")`
  padding: 22px 20px;
`;

export const Title = styled("h1")`
  font-size: 14px;
  margin: 0px;
`;

export const CoverContainer = styled.div<{hasImage: boolean}>`
  width: 100%;
  height: 160px;
  background-color: white;
  overflow: hidden;
  ${props =>
    !props.hasImage &&
    css`
      display: flex;
      justify-content: center;
    `}
`;

export const Cover = styled.img`
  max-width: 100%;
  height: auto;
`;
